
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[slug]",
      function () {
        return require("private-next-pages/stores/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[slug]"])
      });
    }
  